// État vide premium pour tableaux, listes ou modules sans données (KAIZEN SYSTEM).
export function EmptyState({ icon: Icon, title, description, actionLabel, onAction, action }) {
  return (
    <div
      data-testid="empty-state-container"
      className="flex flex-col items-center justify-center p-12 text-center rounded-xl border-2 border-dashed border-zinc-800 bg-zinc-950/30 min-h-[300px] animate-in fade-in duration-500"
    >
      {Icon && (
        <div className="h-16 w-16 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center mb-6 text-zinc-500">
          <Icon size={28} weight="duotone" />
        </div>
      )}
      {title && <h3 className="text-lg font-medium font-cabinet text-zinc-100 mb-2">{title}</h3>}
      {description && (
        <p className="text-sm text-zinc-400 max-w-sm mx-auto mb-8 font-manrope leading-relaxed">{description}</p>
      )}
      {action
        ? action
        : actionLabel && onAction && (
            <button
              type="button"
              onClick={onAction}
              data-testid="empty-state-action"
              className="px-5 py-2.5 rounded-lg bg-amber-500 text-zinc-950 text-sm font-bold tracking-wide hover:bg-amber-400 active:scale-[0.98] transition-all"
            >
              {actionLabel}
            </button>
          )}
    </div>
  );
}

export default EmptyState;
